import { render } from "./detalleServicio.vue?vue&type=template&id=1efe2dfa&scoped=true"
import script from "./detalleServicio.vue?vue&type=script&lang=js"
export * from "./detalleServicio.vue?vue&type=script&lang=js"

import "./detalleServicio.vue?vue&type=style&index=0&id=1efe2dfa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1efe2dfa"]])

export default __exports__